'use strict'

module.exports = function noParagraphAroundImage(md) {
  const defaultImageRenderer =
    md.renderer.rules.image ||
    function (tokens, idx, options, _, self) {
      return self.renderToken(tokens, idx, options)
    }
  const defaultParagraphOpenRenderer =
    md.renderer.rules.paragraph_open ||
    function (tokens, idx, options, _, self) {
      return self.renderToken(tokens, idx, options)
    }
  const defaultParagraphCloseRenderer =
    md.renderer.rules.paragraph_close ||
    function (tokens, idx, options, _, self) {
      return self.renderToken(tokens, idx, options)
    }

  md.renderer.rules.image = function (tokens, idx, options, env, self) {
    // Render the image token as usual
    const result = defaultImageRenderer(tokens, idx, options, env, self)

    // If the image token is inside a paragraph, remove the paragraph tags
    if (
      tokens[idx - 1] &&
      tokens[idx - 1].type === 'paragraph_open' &&
      tokens[idx + 1] &&
      tokens[idx + 1].type === 'paragraph_close'
    ) {
      return result
    }

    return result
  }

  md.renderer.rules.paragraph_open = function (
    tokens,
    idx,
    options,
    env,
    self
  ) {
    // Check if the paragraph contains only an image
    if (
      tokens[idx + 1] &&
      tokens[idx + 1].type === 'inline' &&
      tokens[idx + 1].children &&
      tokens[idx + 1].children.length === 1 &&
      tokens[idx + 1].children[0].type === 'image'
    ) {
      return ''
    }

    return defaultParagraphOpenRenderer(tokens, idx, options, env, self)
  }

  md.renderer.rules.paragraph_close = function (
    tokens,
    idx,
    options,
    env,
    self
  ) {
    // Check if the paragraph contains only an image
    if (
      tokens[idx - 1] &&
      tokens[idx - 1].type === 'inline' &&
      tokens[idx - 1].children &&
      tokens[idx - 1].children.length === 1 &&
      tokens[idx - 1].children[0].type === 'image'
    ) {
      return ''
    }

    return defaultParagraphCloseRenderer(tokens, idx, options, env, self)
  }
}
